class NewsSelector extends HTMLElement {
  constructor() {
    super();

    this.setSource(1);
    this.addEventListener("click", this.selectSource.bind(this));
  }

  setSource(num) {
    let source = document.querySelector(`.news-source[data-id="${num}"]`);
    let selector = document.querySelector(
      `.news-selector[data-id="${num}"]`
    ).parentNode;

    selector.classList.remove("tw-opacity-40");
    selector.classList.add("tw-opacity-100");

    source.classList.remove("tw-hidden", "tw-opacity-0");
    source.classList.add("active", "tw-opacity-100");
  }

  selectSource() {
    let activeSelector = document.querySelector("news-selector.tw-opacity-100");
    let activeSource = document.querySelector(".news-source.active");
    let newSourceID = this.querySelector("img").dataset.id;
    let newSource = document.querySelector(`.news-source[data-id="${newSourceID}"]`);

    activeSelector.classList.remove("tw-opacity-100");
    activeSelector.classList.add("tw-opacity-40");

    this.classList.remove("tw-opacity-40");
    this.classList.add("tw-opacity-100");

    activeSource.classList.remove("tw-opacity-100");
    activeSource.classList.add("tw-opacity-0");

    activeSource.addEventListener("transitionend", () => {
      activeSource.classList.add("tw-hidden");
      activeSource.classList.remove("active");

      newSource.classList.remove("tw-hidden", "tw-opacity-0");
      newSource.classList.add("tw-opacity-100", "active");
    }, { once: true });
  }
}

customElements.define("news-selector", NewsSelector);
